import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'

Vue.use(VueRouter)

// 路由配置
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login.vue')
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '数据统计', breadcrumb: ['数据统计'] }
      },
      {
        path: 'asset-type',
        name: 'AssetType',
        component: () => import('@/views/asset-type/index.vue'),
        meta: { title: '资产类型管理', breadcrumb: ['资产类型管理'] }
      },
      {
        path: 'asset/storage',
        name: 'AssetStorage',
        component: () => import('@/views/asset/storage.vue'),
        meta: { title: '资产入库', breadcrumb: ['资产管理', '资产入库'] }
      },
      {
        path: 'asset/editStorage',
        name: 'AssetEditStorage',
        component: () => import('@/views/asset/editStorage.vue'),
        meta: { title: '编辑资产', breadcrumb: ['资产管理', '编辑资产'] }
      },
      {
        path: 'asset/viewStorage',
        name: 'AssetViewStorage',
        component: () => import('@/views/asset/viewStorage.vue'),
        meta: { title: '资产详情', breadcrumb: ['资产管理', '资产详情'] }
      },
      {
        path: 'asset/list',
        name: 'AssetList',
        component: () => import('@/views/asset/list.vue'),
        meta: { title: '资产列表', breadcrumb: ['资产管理', '资产列表'] }
      },
      {
        path: 'repair',
        name: 'Repair',
        component: () => import('@/views/repair/index.vue'),
        meta: { title: '资产维修记录', breadcrumb: ['资产维修记录'] }
      },
      {
        path: 'repair/detail',
        name: 'RepairDetail',
        component: () => import('@/views/repair/detail.vue'),
        meta: { title: '资产维修详情', breadcrumb: ['资产维修记录', '资产维修详情'] }
      },
      {
        path: 'operation-log',
        name: 'OperationLog',
        component: () => import('@/views/operation-log/index.vue'),
        meta: { title: '操作日志', breadcrumb: ['操作日志'] }
      },
      {
        path: 'operation-log/detail',
        name: 'OperationLogDetail',
        component: () => import('@/views/operation-log/detail.vue'),
        meta: { title: '操作日志详情', breadcrumb: ['操作日志', '操作日志详情'] }
      },
      {
        path: 'system/role',
        name: 'Role',
        component: () => import('@/views/system/role.vue'),
        meta: { title: '角色管理', breadcrumb: ['系统管理', '角色管理'] }
      },
      {
        path: 'system/user',
        name: 'User',
        component: () => import('@/views/system/user.vue'),
        meta: { title: '用户管理', breadcrumb: ['系统管理', '用户管理'] }
      },
      {
        path: 'system/control-unit',
        name: 'ControlUnit',
        component: () => import('@/views/system/ControlUnit.vue'),
        meta: { title: '控制名称管理', breadcrumb: ['系统管理', '控制名称管理'] }
      },
      {
        path: 'system/sms-template',
        name: 'SmsTemplate',
        component: () => import('@/views/system/sms-template.vue'),
        meta: { title: '短信模板管理', breadcrumb: ['系统管理', '短信模板管理'] }
      },
      {
        path: 'system/sms-record',
        name: 'SmsRecord',
        component: () => import('@/views/system/sms-record.vue'),
        meta: { title: '短信记录管理', breadcrumb: ['系统管理', '短信记录管理'] }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.path === '/login') {
    next()
  } else {
    if (!token) {
      next('/login')
    } else {
      next()
    }
  }
})

export default router 